import { fallback } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { VesselStatus } from '../js/vessel/VesselOverview/types/VesselStatus';

export const vesselsSearchSchema = z.object({
    searchQuery: fallback(z.string(), '').default(''),
    customerIds: fallback(z.array(z.string()), []).default([]),
    defaultSupplierIds: fallback(z.array(z.string()), []).default([]),
    page: fallback(z.number(), 0).default(0),
    tab: fallback(z.nativeEnum(VesselStatus), VesselStatus.ACTIVE).default(VesselStatus.ACTIVE),
});
